/**
 * Copyright (c) Stanislav Shishankin
 *
 * This source code is licensed under the MIT license.
 */

class EventsGroup{
    add(listener, prepend){
        let toGroup = this.many;
        
        if (listener instanceof EventListener){
            this.self.emit('newListener', this.name, listener);

            if (prepend){
                toGroup.unshift(listener);
            }else{
                toGroup.push(listener);
            }
            
            //listener.__zzAddGroup(this);
        }
    }
    
    remove(listener){
        if (listener instanceof EventListener){
            let i = this.many.indexOf(listener);
            if (i !== -1){
                this.self.emit('removeListener', this.name, this.many.splice(i, 1)[0]);
            }
        }
    }
    
    removeFn(fn){
        this.many = this.many.filter(l => {
            if (l.fn === fn){
                this.self.emit('removeListener', this.name, l);
                return false;
            }
            return true;
        });
    }
    
    removeBySelf(self){
        this.many = this.many.filter(l => {
            if (l.self === self){
                this.self.emit('removeListener', this.name, l);
                return false;
            }
            return true;
        });
    }
    
    removeAll(){
        let m = this.many;
        
        this.many = [];
        
        for (let ml of m){
            this.self.emit('removeListener', this.name, ml);
        }

        return this;
    }
    
    emit(argsArray){
        let events = this.many.slice(0);
        for (let ev of events){
            ev.run(argsArray);
        }
    }

    listenerCount(){
        return this.many.length;
    }
    
    constructor(name, self){
        this.name = name;
        this.many = [];
        this.self = self;
    }
}

class EventListener{
    off(){
        this.group.remove(this);
        
        return this;
    }

    on(){
        return this.group.self.on.apply(this.group.self, arguments);
    }
    
    run(argsArray){
        if (this.isCalled){
            return this;
        }
        
        this.isCalled = true;
        this.fn.apply(this.self, argsArray);
        this.isCalled = false;
        
        return this;
    }
    
    call(){
        if (this.isCalled){
            return this;
        }
        
        this.isCalled = true;
        this.fn.apply(this.self, arguments);
        this.isCalled = false;
        
        return this;
    }

    constructor(group, fn, self){
        this.fn = fn;

        this.self = self;
        this.isCalled = false;
        this.group = group;
    }
}

class Event{
    __zzGetEvents(){
        return this.__zzEvents;
    }
    
    __zzGetEvent(name){
        return this.__zzEvents[name];
    }
    
    __zzCheckExistsEvent(name){
        if (!this.__zzEvents[name]){
            this.__zzEvents[name] = new EventsGroup(name, this);
        }
        return this.__zzEvents[name];
    }
    
    __zzAddEventListener(name, fn, self, prepend){
        self || (self = this);
        prepend || (prepend = false);

        let evGroup = this.__zzCheckExistsEvent(name);

        let evListener = new EventListener(evGroup, fn, self);
        
        evGroup.add(evListener, prepend);

        return evListener;
    }
    
    on(name, fn, self){
        return this.__zzAddEventListener(name, fn, self, false);
    }

    once(name, fn, self){
        const _ev = this.__zzAddEventListener(name, () => {
            _ev.off();
            fn.apply(this, arguments);
        }, self, false);

        return _ev;
    }

    prependListener(name, fn, self){
        return this.__zzAddEventListener(name, fn, self, true);
    }

    prependOnceListener(name, fn, self){
        const _ev = this.__zzAddEventListener(name, () => {
            _ev.off();
            fn.apply(this, arguments);
        }, self, true);

        return _ev;
    }

    /**
     * remove event listener by name, function or class object
     *
     * @param {string} [name] - event name 
     * @param {string} [fn] - event function
     * @param {string} [self] - event class object
     */
    off(evName, fn, self){
        !fn && (fn = self);

        if (typeof evName === 'string'){
            let evGroup = this.__zzEvents[evName];

            if (evGroup){
                if (typeof fn === 'function'){
                    evGroup.removeFn(fn);
                }else{
                    evGroup.removeBySelf(fn);
                }
            }
        }else{
            let events = this.__zzEvents;
            if (typeof evName === 'function'){
                for (let eventName in events){
                    events[eventName].removeFn(evName);
                }
            }else if (evName){
                for (let eventName in events){
                    events[eventName].removeBySelf(evName);
                }
            }else{
                for (let eventName in events){
                    events[eventName].removeAll();
                }//*/
                this.__zzEvents = [];
            }
        }
    }
    
    listenerCount(name){
        let group = this.__zzEvents[name];
        return group?(group.listenerCount()):0;
    }

    /**
     * Emit event
     *
     * @param   {string} name - key/index of the element in the list of jobs
     */
    emit(name){
        let evGroup = this.__zzEvents[name];
        if (evGroup){
            evGroup.emit( Array.prototype.slice.call(arguments, 1) );

            return true;
        }        
        
        return false;
    }
        
    /* Event helpers */

    /**
     * Delay event run by time
     * 
     * @param {function} EventFunction
     * @param {int} [Time = 0]
     */
    static Defer(fn, time){
        time || (time = 0);
        let timer = true;
        
        let timeoutfn = () => {
            timer = true;

            fn.call(this);
        };

        return function(){
            if (timer){
                timer = false;
                setTimeout(timeoutfn, time);
            }
        };
    }

    static AvoidRunner(){
        return new EventAvoidRunner;
    }

    /**
     * Make event, that avoid selfs
     * 
     * @param {function} EventFunction
     * @param {...Event.AvoidRunner} AvoidRunners
     */
    static avoid(fn){
        //let targs = Array.prototype.slice.call(arguments, 1);
    
        let args;
        for (let run of args){
            if (!(run instanceof EventAvoidRun)){
                console.error('Error: arguments of EventAvoid needs to be EventAvoidRun');
            }
        }

        if (args.length < 1){
            console.error('Error: Event.AvoidRunner\'s objects needs to be more than 1');
        }

        return function(){
            for (let run of args){
                if (run.r){
                    return;
                }
            }
    
            for (let run of args){
                run.r = true;
            }
    
            fn.apply(this, arguments);
    
            for (let run of args){
                run.r = false;
            }
        }
    }

    constructor(){
        this.__zzEvents = {};

        //aliases
        this.addListener = this.on;
        this.removeListener = this.off;
        this.callListener = this.emit;
    }
};

class EventAvoidRunner{
    avoid(fn){
        return () => {
            if (this.r){
                return;
            }
            this.r = true;
    
            fn.apply(this, arguments);
    
            this.r = false;
        }
    }

    run(fn){
        if (this.r){
            return;
        }
        this.r = true;

        fn.apply(this, Array.prototype.slice.call(arguments, 1));

        this.r = false;
    }
    
    constructor(){
        this.r = false;
    }
}

class EventInStack{
    run(args){
        this.args[1].apply(this.element, args);

        return this;
    }

    off(){
        let el = this.element;

        let off = (el.off || el.removeEventListener || el.removeListener);

        off.apply(el, this.args);

        return this;
    }

    constructor(element, args){
        this.element = element;
        this.args = args;

        let on = (element.on || element.addEventListener || element.addListener);

        on.apply(element, this.args);
    }
}

class EventStack{
    off(){
        for (let el of this.events){
            el.off();
        }
        
        this.events = [];
        
        return this;
    }
    
    add(/*...*/){
        let el = arguments[0];
        
        if (el instanceof EventListener || el instanceof EventInStack){
            this.events.push(el);
            return el;
        }else{
            let ev = new EventInStack(el, Array.prototype.slice.call(arguments, 1));
            this.events.push(ev);
            return ev;
        }
    }
    
    remove(el){
        let i = this.events.indexOf(el);
        if (i !== -1){
            this.events[i].off();
            this.events.splice(i, 1);
        }
    }

    constructor(){
        this.events = [];
    }
};

module.exports = {EventListener, EventsGroup, Event, EventStack};
